export enum SettlementsStatus {
    sales = 'sales',
    refunds = 'refunds',
    fees = 'fees',
    adjustments = 'adjustments',
    settlements = 'settlements'
}
